class ArvonsSizeGuide extends HTMLElement {
  #events;
  #opener;
  #scroll;
  #styles;

  connectedCallback() {
    this.#events?.abort();
    this.#events = new AbortController();
    const options = { signal: this.#events.signal };
    const dialog = this.querySelector('dialog');
    if (!dialog) return;
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-size-guide-close]')) this.closeDialog();
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDialog();
      }
    }, options);
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.closeDialog(); }, options);
    dialog.addEventListener('close', () => this.#restore(), options);
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-size-guide-trigger]');
      if (trigger?.getAttribute('aria-controls') === dialog.id) this.showDialog(trigger);
    }, options);
  }

  disconnectedCallback() {
    this.closeDialog();
    this.#events?.abort();
  }

  showDialog(trigger) {
    const dialog = this.querySelector('dialog');
    if (!dialog || dialog.open || !this.isConnected) return;
    this.#opener = trigger instanceof HTMLElement ? trigger : document.activeElement;
    this.#scroll = { x: window.scrollX, y: window.scrollY };
    this.#styles = [
      [document.body, 'position'], [document.body, 'top'], [document.body, 'width'],
      [document.documentElement, 'overflow']
    ].map(([element, property]) => [element, property, element.style.getPropertyValue(property), element.style.getPropertyPriority(property)]);
    dialog.showModal();
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.#scroll.y}px`;
    document.body.style.width = '100%';
    document.documentElement.style.overflow = 'hidden';
  }

  closeDialog() {
    const dialog = this.querySelector('dialog');
    if (dialog?.open) dialog.close();
    this.#restore();
  }

  #restore() {
    if (!this.#styles) return;
    for (const [element, property, value, priority] of this.#styles) {
      if (value) element.style.setProperty(property, value, priority);
      else element.style.removeProperty(property);
    }
    this.#styles = undefined;
    window.scrollTo({ left: this.#scroll.x, top: this.#scroll.y, behavior: 'instant' });
    if (this.#opener?.isConnected) this.#opener.focus({ preventScroll: true });
  }
}

if (!customElements.get('arvons-size-guide-component')) customElements.define('arvons-size-guide-component', ArvonsSizeGuide);
